import React from 'react';
import clsx from 'clsx';
import formStyles from '../../../../components/form/form.module.scss';
import { Input } from '../../../../components/uikit/inputs/Input.tsx';
import { Button } from '../../../../components/uikit/buttons/Button.tsx';
import { NegativeActionText } from '../../../../components/uikit/NegativeActionText.tsx';
import { useScopedTranslation } from '../../../../application/localization/useScopedTranslation.ts';
import styles from '../Repairs.module.scss';
import { IconButton } from '../../../../components/uikit/IconButton.tsx';
import Cross from 'assets/icons/close-button-small.svg?react';
import { AdvancedFormReturnType } from '../../../../helpers/form/useAdvancedForm.ts';
import { FormParams } from '../Repairs.tsx';
import { useWatch } from 'react-hook-form';
import { tDynamic } from '../../../../helpers/tDynamic.ts';
import {
  MultiSelectChips,
  MultiSelectOption,
} from '../../../../components/uikit/inputs/MultiSelectChips.tsx';
import { allStatusFilters } from './statuses.ts';

type FilterProps = {
  form: AdvancedFormReturnType<FormParams>;
  incomingNumber: string;
  serialNumber: string;
  isResetButtonShow: boolean;
  resetFilters: () => void;
};

export const Filters = (props: FilterProps) => {
  const {
    form,
    isResetButtonShow,
    resetFilters,
    serialNumber,
    incomingNumber,
  } = props;

  const i18n = useScopedTranslation('Page.Repairs');

  const [selectedStatuses] = useWatch({
    control: form.control,
    name: ['selectedStatuses'],
  });

  const setSelectedStatuses = (value: MultiSelectOption[]) => {
    form.setValue('selectedStatuses', value);
  };

  return (
    <form onSubmit={form.handleSubmitDefault}>
      <div className={clsx(formStyles.rowContainer, styles.filterContainer)}>
        <Input
          testId={'incoming-number-input'}
          className={clsx(styles.width212)}
          leftHelperText={i18n.t('incoming_number')}
          {...form.register('incomingNumber')}
          endAdornment={
            <div>
              {incomingNumber && (
                <IconButton
                  type={'destroy'}
                  onClick={() => form.setValue('incomingNumber', '')}
                >
                  <Cross />
                </IconButton>
              )}
            </div>
          }
          endAdornmentClassname={styles.endAdornmentClassname}
        />
        <Input
          testId={'serial-number-input'}
          className={clsx(styles.width264)}
          leftHelperText={i18n.t('sn')}
          {...form.register('serialNumber')}
          endAdornment={
            <div>
              {serialNumber && (
                <IconButton
                  type={'destroy'}
                  onClick={() => form.setValue('serialNumber', '')}
                >
                  <Cross />
                </IconButton>
              )}
            </div>
          }
          endAdornmentClassname={styles.endAdornmentClassname}
        />
        <div className={clsx(styles.rowContainer, styles.columnGap8)}>
          <div className={clsx(styles.greyText, styles.center)}>
            {i18n.t('status')}
          </div>
          <MultiSelectChips
            options={allStatusFilters as MultiSelectOption[]}
            selected={selectedStatuses as MultiSelectOption[]}
            onChange={setSelectedStatuses}
            getOptionLabel={(option) => tDynamic(i18n, option.label)}
            chooseLabel={i18n.t('choose_status')}
            selectAllLabel={i18n.t('select_all')}
            moreLabel={i18n.t('more')}
          />
        </div>
        <Button
          testId={'filters-apply-button'}
          type={'submit'}
          className={clsx(formStyles.actionButton, styles.marginLeft16)}
          title={i18n.t('apply')}
        />
        {isResetButtonShow && (
          <NegativeActionText
            testId={'filters-reset-button'}
            text={i18n.t('reset')}
            onClickHandler={resetFilters}
            containerClassName={styles.marginLeft16}
          />
        )}
      </div>
    </form>
  );
};
